export const userInfo = (state) => state.userInfo;
export const token = (state) => state.token;
export const tenantInfo = (state) => state.tenantInfo;
export const advanceSearchGroup = (state) => state.advanceSearchGroup;
export const agreeState = (state) => state.agreeState;
export const currentPaperInfo = (state) => state.currentPaperInfo;
export const language =  (state) => state.language;
export const systemInfo =  (state) => state.systemInfo;
